import React, {PropsWithChildren} from 'react';
import {FrameContextProvider} from '../hooks/useFrame';

const withFrameProvider =
  <T,>(Component: React.FC<T>) =>
  (props: PropsWithChildren<T>) => {
    return (
      <FrameContextProvider>
        <Component {...props} />
      </FrameContextProvider>
    );
  };

export default withFrameProvider;
